import { bl_fi_budget_register_RowClass } from '../../../dbschema/bl_fi_budget_register.model';
import { BaseContainerModel } from '../../base-container.model';


export class BudgetRegisterContainerModel extends BaseContainerModel {
    bl_fi_budget_register: bl_fi_budget_register_RowClass = new bl_fi_budget_register_RowClass();
}
